module.exports = __webpack_public_path__ + "img/LoveIs.7d5963b9.png";